// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { AstatDailyMovementFragmentFragment } from '../../fragments/generated/astat-daily-movement.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CheckAstatDailyGuestsInClosurePeriodQueryVariables = Types.Exact<{
  checkAstatDailyGuestsInClosurePeriodRequestDTO: Types.CheckAstatDailyGuestsInClosurePeriodRequestDtoInput;
}>;


export type CheckAstatDailyGuestsInClosurePeriodQueryResult = { __typename?: 'Query', checkAstatDailyGuestsInClosurePeriod: { __typename?: 'CheckAstatDailyGuestsInClosurePeriodResponseDTO', zeroArrivesAndPresences: boolean, movements: Array<{ __typename?: 'AstatDailyMovementProtoDTO', date: LocalDate, occupiedUnits: number, open: boolean, totalArrivals: number, totalDepartures: number, totalGuestsPresent: number }> } };

export const CheckAstatDailyGuestsInClosurePeriodGql = gql`
    query CheckAstatDailyGuestsInClosurePeriod($checkAstatDailyGuestsInClosurePeriodRequestDTO: CheckAstatDailyGuestsInClosurePeriodRequestDTOInput!) {
  checkAstatDailyGuestsInClosurePeriod(
    checkAstatDailyGuestsInClosurePeriodRequestDTO: $checkAstatDailyGuestsInClosurePeriodRequestDTO
  ) {
    zeroArrivesAndPresences
    movements {
      ...AstatDailyMovementFragment
    }
  }
}
    ${AstatDailyMovementFragmentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckAstatDailyGuestsInClosurePeriodInjectable extends Apollo.Query<CheckAstatDailyGuestsInClosurePeriodQueryResult, CheckAstatDailyGuestsInClosurePeriodQueryVariables> {
    override document = CheckAstatDailyGuestsInClosurePeriodGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */